module.exports = __webpack_public_path__ + "static/desktop-main-guest01-050db60ddc5e2865adce0f0efe0732c7.png";